export const JpdRoadmapIcon = () => (
	<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#a)">
			<rect x="2" y="2" width="36" height="36" rx="4" fill="#EED7FC" />
			<path
				d="M14.233 12.479h8.575a4.438 4.438 0 0 1 0 8.875h-5.325a2.07 2.07 0 1 0 0 4.142h8.575v2.366h-8.575a4.438 4.438 0 0 1 0-8.875h5.325a2.07 2.07 0 1 0 0-4.141h-8.575z"
				fill="#AF59E0"
			/>
			<path
				d="M14.233 17.183a3.55 3.55 0 1 0 0-7.1 3.55 3.55 0 0 0 0 7.1m15.087 6.225h-6.507v6.508h6.508z"
				fill="#BF63F3"
			/>
			<path d="M17.588 12.479a3.53 3.53 0 0 1-.025 2.367h-3.33v-2.367z" fill="#09326C" />
			<path
				d="M17.78 13.629c0 .43-.076.838-.218 1.217h-3.329v-2.367h3.354c.125.363.192.746.192 1.15m7.659 15.779v-1.55h-2.625v-2.367h2.625v-1.55l2.729 2.734z"
				fill="#09326C"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<rect width="40" height="40" rx="4" fill="#fff" />
			</clipPath>
		</defs>
	</svg>
);
